import React, { useEffect } from 'react';

import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useNavigate } from 'react-router';

const AppUrlListener: React.FC<any> = () => {
	const navigate = useNavigate();
	useEffect(() => {
		App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
			// Example url: https://app.asaph.io/page?q=1
			// slug = /page?q=1
			const slug = event.url.split('app.asaph.io').pop();
			if (slug) {
				navigate(slug);
			}
			// If no match, do nothing - let regular routing
			// logic take over
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export default AppUrlListener;
